<form [formGroup]="receiptForm" (ngSubmit)="onSubmit()">
  <label for="email">Email Address:</label>
  <input
    id="email"
    type="email"
    formControlName="email"
    [class.invalid]="receiptForm.get('email')?.invalid && receiptForm.get('email')?.touched"
    placeholder="Enter your email"
  />

  <div class="error" *ngIf="receiptForm.get('email')?.hasError('required') && receiptForm.get('email')?.touched">
    Email is required
  </div>
  <div class="error" *ngIf="receiptForm.get('email')?.hasError('email') && receiptForm.get('email')?.touched">
    Please enter a valid email address
  </div>

  <button type="submit" [disabled]="receiptForm.invalid || submitting">
    {{ submitting ? 'Sending...' : 'Send Receipt' }}
  </button>
</form>

<div *ngIf="message" class="message">{{ message }}</div>